import { GridColDef } from '@microservices/wiskey-react-table-component'
import { ICON_REGISTRY } from './iconRegistry'
import { MobileApp, VectorIcon } from '@mobileTypes'
import { Box } from '@mui/material'

export const MOBILE_APPS_COLUMNS: GridColDef[] = [
  {
    field: 'icon',
    headerName: 'Icon',
    width: 80,
    renderCell: (params: any) => {
      const app = params.row as MobileApp
      const icon = app.icon
      if (!icon) return null

      let iconData: VectorIcon
      if (typeof icon === 'string') {
        try {
          iconData = JSON.parse(icon)
        } catch {
          return <span>{icon}</span>
        }
      } else {
        iconData = icon
      }

      const iconItem = ICON_REGISTRY.find(
        item => item.id === iconData.value && item.library === iconData.type
      )

      if (!iconItem) {
        return <span>{iconData.value}</span>
      }

      const IconComponent = iconItem.Component
      const color = iconData.color || '#FFFFFF'
      const bgColor = app.backgroundColor || '#7FB5B5'

      return (
        <Box
          sx={{
            width: 40,
            height: 40,
            backgroundColor: bgColor,
            borderRadius: '10px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <IconComponent size={20} color={color} />
        </Box>
      )
    },
  },
  {
    field: 'internalId',
    headerName: 'Internal ID',
    flex: 1,
    minWidth: 120,
  },
  {
    field: 'title',
    headerName: 'Title',
    flex: 1,
    minWidth: 200,
  },
  {
    field: 'startScreen',
    headerName: 'Start Screen',
    flex: 1,
    minWidth: 150,
  },
]

export const DEFAULT_MOBILE_APP: Omit<MobileApp, 'id'> = {
  internalId: '',
  title: '',
  startScreen: '',
  icon: null,
  backgroundColor: '#7FB5B5',
  keepAwake: false,
  drawerItems: [],
  screenIds: [],
  eventFlows: [],
  wsNotifications: [],
}
